class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.summaryElement = this.querySelector('summary.quick-view__summary');
    this.detailsElement = this.summaryElement.closest('details');
    this.quickViewContent = document.body.querySelector('quick-view.product-card__quick-view .quick-view__content--product');

    this.adjustSummaryPosition();
    window.addEventListener('resize', () => this.adjustSummaryPosition());

    this.summaryElement.addEventListener('click', (e) => this.handleSummaryClick(e));
  }

  adjustSummaryPosition() {
    const mediaElement = this.closest('.product-card-wrapper')?.querySelector('.card .card__inner');

    if (mediaElement && mediaElement.querySelector('.card__media')) {
      setTimeout(() => {
        const height = mediaElement.getBoundingClientRect().height;
        this.summaryElement.style.setProperty('top',`${height - 14}px`, 'important');
      }, 100);
    }
  }

  async handleSummaryClick (event) {
    event.preventDefault();

    const currentUrl = window.location.href;
    const breadcrumbs = JSON.parse(window.localStorage.getItem('breadcrumbs'));
    if (!currentUrl.endsWith(breadcrumbs[breadcrumbs.length - 1].url)) {
      window.localStorage.setItem('breadcrumbs', JSON.stringify([window.baseBreadcrumb]));
    }

    fetch(`${this.getAttribute('data-product-url')}`)
    .then(response => response.text())
    .then((data) => {
      const responseHTML = new DOMParser().parseFromString(data, 'text/html');
      this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
      const element = this.productElement.querySelector('div.page-width');
      if (element) {
        element.classList.remove('page-width');
        element.classList.add('quick-view__content--product-wrapper');
      }

      const sizeGuideModalDialog = responseHTML.querySelector('modal-dialog.variant-picker__popup-modal');
      if (sizeGuideModalDialog) {
        document.body.appendChild(sizeGuideModalDialog);
      }

      this.preventDuplicatedIDs();
      this.removeDOMElements();
      this.setInnerHTML(this.quickViewContent, this.productElement.innerHTML);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.removeGalleryListSemantic();
      this.updateImageSizes();
      this.preventVariantURLSwitching();

      document.body.classList.add('quick-view--open');
      this.detailsElement.setAttribute('open', '');
      this.detailsElement.classList.add('menu-opening');
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickview-${sectionId}`);
    this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
      element.dataset.originalSection = sectionId;
    });
  }

  removeDOMElements() {
    const pickupAvailability = this.productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector('product-modal');
    if (productModal) productModal.remove();

    const modalDialog = this.productElement.querySelectorAll('modal-dialog');
    if (modalDialog) modalDialog.forEach((modal) => modal.remove());
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  removeGalleryListSemantic() {
    const galleryList = this.quickViewContent.querySelector('[id^="Slider-Gallery"]');
    if (!galleryList) return;

    galleryList.setAttribute('role', 'presentation');
    galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
  }

  updateImageSizes() {
    const product = this.quickViewContent.querySelector('.product');
    const desktopColumns = product.classList.contains('product--columns');
    if (!desktopColumns) return;

    const mediaImages = product.querySelectorAll('.product__media img');
    if (!mediaImages.length) return;

    let mediaImageSizes =
      '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

    if (product.classList.contains('product--medium')) {
      mediaImageSizes = mediaImageSizes.replace('715px', '605px');
    } else if (product.classList.contains('product--small')) {
      mediaImageSizes = mediaImageSizes.replace('715px', '495px');
    }

    mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
  }

  preventVariantURLSwitching() {
    const variantPicker = this.quickViewContent.querySelector('variant-selects');
    if (!variantPicker) return;

    variantPicker.setAttribute('data-update-url', 'false');
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('.quick-view__close-button');
    this.closeButton.addEventListener('click', () => this.onCloseButtonClick());
  }

  onCloseButtonClick() {
    document.body.classList.remove('quick-view--open');
    const detailsElement = document.querySelector('quick-view-drawer > details[open].menu-opening');
    detailsElement.removeAttribute('open');
    detailsElement.classList.remove('menu-opening');
    document.body.classList.remove(`overflow-hidden-important`);
  }
}
customElements.define('quick-view', QuickView);
